import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AgentCreatePage } from "@/features/agent-inventory/create/agent-create-page";

export const Route = createFileRoute("/agent-inventory/new")({
  component: () => (
    <PermissionGuard module="agent_inventory" action="create">
      <AgentCreatePage />
    </PermissionGuard>
  ),
});
